
import { Component, OnInit, input } from '@angular/core';
import { AuthPipe } from '@shared/pipes/auth.pipe';
import { AuthAccess } from 'app/auth/models/auth-access';
import { AuthAccessLogicalType } from 'app/auth/models/auth-access-logical-type';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss'],
    imports: [],
    providers: [AuthPipe]
})
export class AuthComponent implements OnInit {

  readonly authAccess = input<AuthAccess[]>();
  
  readonly authAccessLogicalType = input<AuthAccessLogicalType>(AuthAccessLogicalType.Or);

  isShow: boolean = false;

  private subscriptions: Subscription[] = [];

  constructor(private authPipe: AuthPipe) {

  }

  // Show if has correctly roles
  ngOnInit(): void {
    this.authPipe.transform(this.authAccess(), this.authAccessLogicalType()).subscribe(hasAccess => this.isShow = hasAccess);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
